import Vue from 'vue'
import App from './App.vue'
import router from './router'

// 引入 ElementUI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// 引入 字体
// import './assets/fonts/iconfont.css'

// 引入 ECharts
// import ECharts from 'vue-echarts/components/ECharts'
// import 'echarts/lib/chart/line'
// import 'echarts/lib/component/tooltip'
// Vue.component('chart', ECharts)

// 引入 store
// import store from './store'
// import moment from 'moment'
// Vue.prototype.$moment = moment //方便在vue组件中可以直接使用 this.$moment -> moment

// 引入mqtt
import './mq'

// 将自动注册所有组件为全局组件
import dataV from '@jiaminghi/data-view'

Vue.use(ElementUI)
Vue.use(dataV)

// 系统文件
Vue.config.productionTip = false

// 封装 $confirm 为 Promise
Vue.prototype.$confirmPromise = function (message, title, options = {}) {
  return new Promise((resolve, reject) => {
    this.$confirm(message, title, options)
      .then(() => resolve('Y'))
      .catch(() => resolve('N'))
  })
}

// 全局提示音
Vue.prototype.$beep = function (volume = 1) {
  try {
    // const audio = new Audio(
    //   'data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2/LDciUFLIHO8tiJNwgZaLvt559NEAxQp+PwtmMcBjiR1/LMeSwFJHfH8N2QQAoUXrTp66hVFApGn+DyvmImBze5u+wVRwASe7UAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA='
    // )
    const audio = new Audio('/raw/beep.mp3')
    audio.volume = Math.max(0, Math.min(1, volume))
    audio.play().catch(() => {})
  } catch (e) {}
}

// 自带不能修改
window.history.pushState(null, null, window.Location.href)
window.addEventListener('popstate', function () {
  window.history.forward(-1)
  window.history.pushState(null, null, window.Location.href)
})

const vue = new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

export default vue
